<template>
    <Card :customClasses="variantClasses" :title="props.title">
        <div class="tw:flex tw:items-center tw:gap-3 ">
            <div v-if="props.loading" class="tw:w-6 tw:h-6 tw:border-2 tw:border-gray-300 tw:border-t-blue-500 tw:rounded-full tw:animate-spin"></div>
            <template v-else>
                <span class="tw:text-xl tw:md:text-2xl tw:lg:text-3xl tw:font-bold tw:text-gray-800 tw:truncate">{{ props.value }}</span>
                <i v-if="props.icon" :class="[props.icon, props.iconColor]" class="tw:text-2xl"></i>
                <span v-if="props.suffix" class="tw:text-sm tw:font-medium tw:text-gray-400">{{ props.suffix }}</span>
            </template>
        </div>

        <slot></slot>
    </Card>
</template>

<script setup>
    import Card from '@/modules/admin/ui/Card.vue'
    import { computed } from 'vue';

    const props = defineProps({
        title: String,
        value: [String, Number],
        icon: String,
        iconColor: { type: String, default: 'text-primary' },
        suffix: String,
        variant: { type: String, default: null },
        loading: { type: Boolean, default: false },
        customClass: { type: String, default: '' },
        dataCy: { type: String, default: '' }
    });

    const variantClasses = computed(() => {
        const map = {
            success: 'tw:border-l-2 tw:border-l-gray-200 tw:hover:border-l-8 tw:hover:border-l-green-500',
            primary: 'tw:border-l-2 tw:border-l-gray-200 tw:hover:border-l-8 tw:hover:border-l-blue-500',
            warning: 'tw:border-l-2 tw:border-l-gray-200 tw:hover:border-l-8 tw:hover:border-l-yellow-500',
            danger:  'tw:border-l-2 tw:border-l-gray-200 tw:hover:border-l-8 tw:hover:border-l-red-500',
        };
        return props.variant ? map[props.variant] : '';
    });
</script>